module.exports = __webpack_public_path__ + "static/malcolm-davis-84f427e9208b3820dcce54688f249b6e.jpg";